// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2lgt_","detailsBorder":"styles_detailsBorder__2Zyur"};